module.exports = __webpack_public_path__ + "static/media/image3.475bc0fb.PNG";